import { oc } from "@orpc/contract";
import { openapi } from "@orpc/openapi";
import { z } from "zod";

export const billingSessionSchema = z.object({
  type: z.enum(["customer_session", "billing_session"]),
  url: z.url({ protocol: /^https$/ }),
});
export type BillingSession = z.output<typeof billingSessionSchema>;
export const billingSessionContract = {
  createBillingSession: oc
    .errors({
      BAD_REQUEST: { message: "Invalid request" },
      UNAUTHORIZED: { message: "Authentication required" },
      FORBIDDEN: { message: "Account required" },
      METHOD_NOT_ALLOWED: { message: "Method Not Allowed" },
      INTERNAL_SERVER_ERROR: { message: "Internal Server Error" },
      SERVICE_UNAVAILABLE: { message: "Billing unavailable" },
    })
    .input(
      z.object({
        query: z.strictObject({}).default({}),
        body: z.strictObject({}),
      }),
    )
    .meta(
      openapi({
        method: "POST",
        path: "/api/v2/me/billing/sessions",
        inputStructure: "detailed",
        successStatus: 200,
        spec: (spec) => ({ ...spec, security: [{ bearerAuth: [] }] }),
      }),
    )
    .output(billingSessionSchema),
};
